export default __webpack_public_path__ + "vision-external-camera-thumbnail-960-d3d86e500608ec39b724355f501b42e5.png";